export default __webpack_public_path__ + "static/media/username.2039d717.svg";